import { render, staticRenderFns } from "./HousesView.vue?vue&type=template&id=9a2ab518&scoped=true&"
import script from "./HousesView.vue?vue&type=script&lang=js&"
export * from "./HousesView.vue?vue&type=script&lang=js&"
import style0 from "./HousesView.vue?vue&type=style&index=0&id=9a2ab518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2ab518",
  null
  
)

component.options.__file = "HousesView.vue"
export default component.exports